import { render, staticRenderFns } from "./AppDetailPdf.vue?vue&type=template&id=3b220a06&scoped=true"
import script from "./AppDetailPdf.vue?vue&type=script&lang=js"
export * from "./AppDetailPdf.vue?vue&type=script&lang=js"
import style0 from "./AppDetailPdf.vue?vue&type=style&index=0&id=3b220a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b220a06",
  null
  
)

export default component.exports